import React from "react";

function GMap() {
  return (
    <div className="boreder rounded-5">
      <iframe
        className="rounded-3"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.8709650528995!2d78.4244860107433!3d17.36994098344555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb970073b5015f%3A0x179ab4753bf50c99!2sG%20%26%20G%20Business%20Centre!5e0!3m2!1sen!2sin!4v1720010262468!5m2!1sen!2sin"
        width="275"
        height="250"
        loading="lazy"
        frameborder="0"
        
      ></iframe>
      {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.8709650528995!2d78.4244860107433!3d17.36994098344555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb970073b5015f%3A0x179ab4753bf50c99!2sG%20%26%20G%20Business%20Centre!5e0!3m2!1sen!2sin!4v1720010262468!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
    </div>
  );
}

export default GMap;
